/*class BlogFilter extends HTMLElement {
  constructor() {
    super();

    const filter = document.querySelector('select');
    filter.addEventListener('change', function() {
      window.location.href = filter.value;
    });
  }
}

customElements.define('blog-filter', BlogFilter);

*/

class BlogFilter extends HTMLElement {
  constructor() {
    super();

    // Use the more specific selector to find the correct <select> element
    const filter = document.querySelector('select:not(.ly-languages-switcher)');
    if (filter) { // Ensure the element exists before adding the event listener
      filter.addEventListener('change', function () {
        window.location.href = filter.value;
      });
    }
  }
}

customElements.define('blog-filter', BlogFilter);

// Remove empty H1 tags on blog/article pages (including ones with only <br> tags)
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('h1').forEach(function (h1) {
    var clone = h1.cloneNode(true);
    clone.querySelectorAll('br').forEach(function (br) { br.remove(); });
    if (clone.textContent.trim() === '') h1.remove();
  });
});
